/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} _Field_ParticipationsInputs */

const en__field_participations = /** @type {(inputs: _Field_ParticipationsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Participations`)
};

const de__field_participations = /** @type {(inputs: _Field_ParticipationsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Teilnahmen`)
};

/**
* | output |
* | --- |
* | "Participations" |
*
* @param {_Field_ParticipationsInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const _field_participations = /** @type {((inputs?: _Field_ParticipationsInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<_Field_ParticipationsInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en__field_participations(inputs)
	return de__field_participations(inputs)
});